import React from 'react'
import { Switch, Route } from 'react-router-dom'
import HomePage from '../HomePage'
import Login from '../Login'
import ForgotPassword from '../Login/forgotPassword'
import Register from '../Register'
import Dashboard from '../Dashboard'
import Backups from '../Backups'
import Upload from '../Upload'
import Account from '../User/account'
import Settings from '../Settings'

function SwitchRoutes() {
    return (
        <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/forgot" component={ForgotPassword} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/backups" component={Backups} />
            <Route exact path="/upload" component={Upload} />
            <Route exact path='/account' component={Account} />
            <Route exact path='/settings' component={Settings} />
       </Switch>
    )
}

export default SwitchRoutes